{
  "myCases.detail.back": "Back to list",
  "myCases.detail.employer": "Employer",
  "myCases.detail.heading": "Message details",
  "myCases.detail.source": "Source",
  "myCases.detail.closedReplyNote": "This conversation is closed and can no longer be replied to. If you still need help, you can get in touch by starting a new conversation.",
  "myCases.detail.notFound": "Message not found.",
  "myCases.detail.unavailable": "We can’t load this message right now. Please try again later.",
  "myCases.detail.messagesHeading": "Messages",
  "myCases.detail.noMessages": "No messages.",
  "myCases.detail.systemAuthor": "YTK Työelämä",
  "myCases.detail.selfAuthor": "You",
  "myCases.detail.contactSummaryHeading": "Your enquiry",
  "myCases.detail.attachmentsHeading": "Attachments",
  "myCases.detail.download": "Download",
  "myCases.detail.attachmentBeingChecked": "This attachment is being security-checked and can’t be downloaded right now.",
  "myCases.detail.downloadFailed": "Download failed. Please try again later.",
  "myCases.detail.replyLabel": "Reply",
  "myCases.detail.replyPlaceholder": "Write your reply…",
  "myCases.detail.removeAttachment": "Remove attachment",
  "myCases.detail.uploadTooMany": "Too many attachments. Remove one before sending.",
  "myCases.detail.replySend": "Send reply",
  "myCases.detail.replySending": "Sending…",
  "myCases.detail.replySent": "Reply sent.",
  "myCases.detail.replyFailed": "We couldn’t send your reply just now. Please try again.",
  "myCases.detail.replyEmpty": "Write a message or add an attachment before sending.",
  "myCases.detail.replyTooLong": "Your reply is too long (4,000 characters max). Please shorten it.",
  "myCases.detail.uploadLabel": "Add an attachment (PDF, PNG, JPEG, DOCX or XLSX, max 25 MB)",
  "myCases.detail.chooseFile": "Choose file",
  "myCases.detail.attachmentCountHint": "Up to {max} attachments ({count} selected)",
  "myCases.detail.charCountUnit": "characters",
  "myCases.detail.uploadBeingChecked": "Attachment sent. It’s being security-checked and can’t be downloaded yet.",
  "myCases.detail.uploadTooLarge": "That file is too large. Please try a smaller one.",
  "myCases.detail.uploadUnsupported": "That file type isn’t supported. Allowed types: PDF, PNG, JPEG, DOCX and XLSX.",
  "myCases.detail.uploadFailed": "We couldn’t upload your attachment just now. Please try again.",
  "myCases.empty": "You have no messages yet.",
  "myCases.heading": "My messages",
  "myCases.source.ai_originated": "From Lakikaveri conversation",
  "myCases.source.standalone_contact": "Contact form",
  "myCases.status.acknowledged": "Acknowledged",
  "myCases.status.closed": "Closed",
  "myCases.status.created": "Created",
  "myCases.status.failed": "Failed",
  "myCases.status.routed": "Routed for review",
  "myCases.loading": "Loading…",
  "myCases.unavailable": "We can’t load your messages right now. Please try again later.",
  "myCases.untitled": "Untitled message",
  "myCases.unread": "Unread",
  "myCases.statusPrefix": "Status:",
  "myCases.loadMore": "Load more messages",
  "myCases.loadingMore": "Loading more messages…",
  "myCases.moreLoaded": "More messages loaded. {count} messages now shown.",
  "myCases.allShown": "All messages shown.",
  "myCases.loadMoreFailed": "We couldn’t load more messages right now. Please try again."
}
